import React from 'react';
import Header from '../Components/Header'
import InfoBodySaving from '../Components/InfoBodySaving';


const InfoSaving = () => {
  return (
    <div className='h-screen w-full'>
      <Header />
      <InfoBodySaving />
    </div>
  );
}

export default InfoSaving;